import React, { useEffect, useState } from 'react';
import moment from "moment";
import OpenApi from '../../api/OpenApi';
import { OpenApiWrapper, OpenApiCard, OpenApiTitle, OpenApiInfo, InfoValue, InfoLabel, InfoSwaggerLink } from './OpenApiManagement.styled';

interface OpenApiManagementProps {
}

const OpenApiManagement: React.FC<OpenApiManagementProps> = (props) => {
    let [openApiInfo, setOpenApiInfo] = useState(null);
    let [initiating, setInitiating] = useState(false);
    let openApiAccount = new OpenApi();

    let fetchOpenApiInfo = async () => {
        let response = await openApiAccount.getOpenApiAccountProfile();
        setOpenApiInfo(response.data.data);
    };

    useEffect(() => {
        fetchOpenApiInfo();
    }, []);

    if (!openApiInfo) {
        return null;
    }

    return (
        <OpenApiWrapper>
            <OpenApiCard>
                <OpenApiTitle>OpenAPI 访问凭证</OpenApiTitle>

                <OpenApiInfo>
                    <InfoLabel>Token</InfoLabel>
                    <InfoValue>{openApiInfo.token}</InfoValue>
                </OpenApiInfo>

                <OpenApiInfo>
                    <InfoLabel>过期时间</InfoLabel>
                    <InfoValue>
                        {moment(parseInt(openApiInfo.expiredTime)).format('YYYY-MM-DD HH:mm:ss')}
                    </InfoValue>
                </OpenApiInfo>

                <OpenApiInfo><InfoSwaggerLink><a href='https://winch.intcon-sys.com/swagger-ui/index.html#/'  target="_blank" >API 文档</a></InfoSwaggerLink></OpenApiInfo>
            </OpenApiCard>
        </OpenApiWrapper>
    );
};

export default OpenApiManagement;